export default __webpack_public_path__ + "static/media/home-banner4.4fe169c1.png";